import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  KEYCRM_TOKEN,
} from '@app/Seller/accessTokens'

const BaseRoute = () => import('@app/Seller/Components/Base')
const KeyCrmBase = () => import('@app/Seller/KeyCrm/Base')
const KeyCrmSettings = () => import('@app/Seller/KeyCrm/Tabs/Settings')
const KeyCrmDeliveryMethods = () => import('@app/Seller/KeyCrm/Tabs/DeliveryMethods')
const KeyCrmPaymentMethods = () => import('@app/Seller/KeyCrm/Tabs/PaymentMethods')
// const KeyCrmStatuses = () => import('@app/Seller/KeyCrm/Tabs/Statuses')
const KeyCrmWebhook = () => import('@app/Seller/KeyCrm/Tabs/Webhook')
const KeyCrmAdditional = () => import('@app/Seller/KeyCrm/Tabs/Additional')
// const KeyCrmOrderList = () => import('@app/Seller/KeyCrm/Order/List')

const MODEL = 'key-crm'

const BASE = `${MODEL}/`

const SETTINGS = ''
const DELIVERY = 'delivery/'
const PAYMENT = 'payment/'
// const STATUSES = 'statuses/'
// const ORDERS = 'orders/'
const WEBHOOK = 'webhook/'
const ADDITIONAL = 'additional/'

export const KEY_CRM_PREFIX = `${MODEL}:`

const p = name => KEY_CRM_PREFIX + name

export const BASE_NAME = p('view')
export const KEY_CRM_BASE_NAME = p('base')
export const KEY_CRM_SETTINGS_NAME = p('settings')
export const KEY_CRM_DELIVERY_NAME = p('delivery')
export const KEY_CRM_PAYMENT_NAME = p('payment')
// export const KEY_CRM_STATUSES_NAME = p('statuses')
export const KEY_CRM_WEBHOOK_NAME = p('webhook')
export const KEY_CRM_ADDITIONAL_NAME = p('additional')
// export const KEY_CRM_ORDER_LIST_NAME = p('order:list')

export function createRoutes(options) {
  return [
    route(BASE, BaseRoute, BASE_NAME, {
      meta: accessPermission(KEYCRM_TOKEN, options),
      redirect: { name: KEY_CRM_SETTINGS_NAME },
      children: [
        route('', KeyCrmBase, KEY_CRM_BASE_NAME, {
          meta: accessPermission(KEYCRM_TOKEN, options),
          redirect: { name: KEY_CRM_SETTINGS_NAME },
          children: [
            route(SETTINGS, KeyCrmSettings, KEY_CRM_SETTINGS_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route(DELIVERY, KeyCrmDeliveryMethods, KEY_CRM_DELIVERY_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route(PAYMENT, KeyCrmPaymentMethods, KEY_CRM_PAYMENT_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            // route(STATUSES, KeyCrmStatuses, KEY_CRM_STATUSES_NAME, {
            //   meta: accessPermission(KEYCRM_TOKEN, options),
            // }),
            route(WEBHOOK, KeyCrmWebhook, KEY_CRM_WEBHOOK_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
            route(ADDITIONAL, KeyCrmAdditional, KEY_CRM_ADDITIONAL_NAME, {
              meta: accessPermission(KEYCRM_TOKEN, options),
            }),
          ],
        }),
        // route(ORDERS, KeyCrmOrderList, KEY_CRM_ORDER_LIST_NAME, {
        //   meta: accessPermission(KEYCRM_TOKEN, options),
        // }),
      ],
    }),
  ]
}
